<template>
    <div class="guide-panel">
        <custom-panel :title="title" :height="height" @moreClick="moreClickHandle">
            <template #content>
                <a-spin :spinning="loading" v-if="guideList.length > 0">
                    <div v-for="item in guideList" :key="item.id" class="notice-item" @click="guideDetailHandle(item)">
                        <div class="notice-title">{{ item.title }}</div>
                        <div class="notice-time">{{ item.publishDate }}</div>
                    </div>
                </a-spin>
                <a-empty style="margin-top: 28px" v-else />
            </template>
        </custom-panel>

        <a-modal
            v-model="modalVisible"
            title="办事指南详情"
            :width="960"
            :footer="null"
            :mask-closable="false"
            :keyboard="false"
        >
            <div v-if="guideDetail" class="modal-guide-detail">
                <div class="modal-guide-title">{{ guideDetail.title }}</div>
                <div class="modal-guide-time">{{ guideDetail.publishDate }}</div>
                <div class="modal-guide-content" v-html="guideDetail.content"></div>
                <div class="modal-guide-file-list" v-if="fileList.length">
                    <div>附件：</div>
                    <div class="list-item" v-for="(item, i) in fileList" :key="item.id">
                        <span>{{ i + 1 }}、</span>
                        <div class="title" @click="downloadFile(item)">{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { queryGuideList, queryGuideDetail } from '../../../common/api';
import CustomPanel from '@/components/custom-panel.vue';
import axios from 'axios';

export default {
    props: {
        height: {
            type: Number
        }
    },

    components: {
        CustomPanel
    },

    data() {
        return {
            title: '办事指南',
            guideList: [],
            guideDetail: {},
            modalVisible: false,
            fileList: [],
            loading: false
        };
    },

    methods: {
        moreClickHandle() {
            this.$router.push({
                path: '/notification',
                query: {
                    code: 'handleGuide'
                }
            });
        },

        async getGuideList() {
            this.loading = true;
            const { data } = await queryGuideList({
                n: 1,
                s: 5,
                // f: { guideType_SEQ: 'inspGuide' }
            });
            this.guideList = data.rows.map(item => {
                return {
                    ...item,
                    title: item.shortName
                };
            });
            this.loading = false;
        },

        async guideDetailHandle(item) {
            this.$set(this.guideDetail, 'content', '');
            this.fileList = [];

            this.guideDetail = item;
            this.modalVisible = true;
            const { data } = await queryGuideDetail(item.id);
            if (data.contentType === '0') {
                this.$set(this.guideDetail, 'content', data.contentList[0]?.content ?? '');
            } else {
                this.fileList = data.contentList.map(item => {
                    return {
                        ...item,
                        name: item.content
                    };
                });
            }
        },

        async downloadFile(file) {
            this.downloadByBlob(file.downloadUrl, file.name);
        },

        downloadByBlob(url, fileName) {
            const pathArr = url?.split('/') ?? [];
            axios.get(url, { responseType: 'blob' }).then(res => {
                const blob = new Blob([res.data]);
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName || pathArr[pathArr.length - 1] || true;
                link.click();
                URL.revokeObjectURL(link.href);
            });
        }
    },

    created() {
        this.getGuideList();
    }
};
</script>

<style lang="scss" scoped>
.guide-panel {
    .notice-item {
        height: 40px;
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
            background: #f0f4fb;
        }

        .notice-title {
            width: calc(100% - 96px);
            padding-left: 20px;
            font-size: 16px;
            color: #333333;
            position: relative;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &::before {
                position: absolute;
                left: 0;
                top: 2px;
                content: '';
                width: 16px;
                height: 16px;
                margin-right: 4px;
                background: url(../imgs/icon-guide.svg) no-repeat center center / contain;
                transform: translateY(2px);
            }
        }

        .notice-time {
            width: 96px;
            margin-left: auto;
            font-size: 14px;
            color: #999999;
            text-align: right;
        }
    }
}

.modal-guide-detail {
    height: 64vh;
    overflow: auto;

    .modal-guide-title {
        font-size: 18px;
        font-weight: 600;
        text-align: center;
    }

    .modal-guide-time {
        margin-bottom: 4px;
        font-size: 14px;
        color: #999999;
        text-align: center;
    }

    .modal-guide-content {
        padding-top: 20px;
        border-top: 1px solid #f1f1f1;
        font-size: 16px;
        color: #333333;
        line-height: 1.5;
        text-align: justify;
    }

    .modal-guide-file-list {
        margin-top: 50px;
        font-size: 14px;

        .list-item {
            display: flex;
            align-items: center;
            height: 30px;
            line-height: 30px;
            .title {
                color: #007fff;
                cursor: pointer;
            }
        }
    }
}


</style>
